import {
  QuestionsActions,
  QuestionsActionTypes,
} from '../actions/questions.actions';
import { ProcessQuestionModel } from '../models/questions.model';

export interface QuestionState {
  questions: ProcessQuestionModel[];
  questionToUpdate: ProcessQuestionModel;
  error: any;
  step_id: number;
  step_type: number;
}

export const initialState: QuestionState = {
  step_id: null,
  step_type: null,
  questions: [],
  questionToUpdate: null,
  error: null,
};

export function questionsReducer(
  state = initialState,
  action: QuestionsActions
): QuestionState {
  switch (action.type) {
    case QuestionsActionTypes.LoadQuestions:
      return {
        ...state,
        questions: action.payload.questions,
        step_type: action.payload.step_type,
        step_id: action.payload.step_id,
      };

    case QuestionsActionTypes.UpdateQuestion:
      return {
        ...state,
        questionToUpdate: action.payload.questionToUpdate,
      };

    case QuestionsActionTypes.CleanState:
      return initialState;

    default:
      return state;
  }
}

export const getQuestions = (state: QuestionState) => state;
